import { LegalPage } from "@/pages/legal/LegalPage";

const EFFECTIVE = "August 12, 2026";
const UPDATED = "August 12, 2026";

export default function TermsOfUse() {
  return (
    <LegalPage
      testid="legal-terms-page"
      title="Terms of Use"
      effectiveDate={EFFECTIVE}
      lastUpdated={UPDATED}
    >
      <p>
        These Terms of Use (the &ldquo;Terms&rdquo;) govern access to and
        use of the <strong>Family Chapel Staff Dashboard</strong>
        (&ldquo;Staff Dashboard&rdquo;). The Staff Dashboard is owned and
        operated by Family Chapel and is provided as an internal
        application for authorized Family Chapel personnel. These Terms
        also serve as the End-User License Agreement for the Staff
        Dashboard.
      </p>

      <h2>Authorized Use</h2>
      <p>
        The Staff Dashboard is intended solely for authorized Family
        Chapel personnel performing work on behalf of Family Chapel.
        Family Chapel may grant, change, suspend, or revoke access to the
        Staff Dashboard, in whole or in part, at any time and for any
        reason.
      </p>

      <h2>Your Responsibilities</h2>
      <ul>
        <li>You are responsible for safeguarding the credentials used to sign in to the Staff Dashboard.</li>
        <li>You agree to use the Staff Dashboard only for authorized Family Chapel church and ministry purposes.</li>
        <li>
          You must not attempt to bypass security or access controls,
          access information you are not authorized to access, interfere
          with the operation of the Staff Dashboard, or misuse
          information obtained through integrations.
        </li>
        <li>
          You must promptly notify Family Chapel if you suspect any
          unauthorized use of your account or the Staff Dashboard.
        </li>
      </ul>

      <h2>Third-Party Integrations</h2>
      <p>
        The Staff Dashboard may integrate with third-party services,
        including but not limited to Google Workspace (Calendar, Drive),
        Pushpay, Mailchimp, and <strong>Intuit QuickBooks Online</strong>.
        Use of those services through the Staff Dashboard may also be
        subject to the applicable terms and policies of those third-party
        providers.
      </p>

      <h2>QuickBooks Online Integration &ndash; Read-Only</h2>
      <p>
        The Staff Dashboard&rsquo;s QuickBooks Online integration provides
        <strong> read-only</strong> access to financial information for
        the purpose of internal reporting and dashboards. The Staff
        Dashboard does not permit users to create, modify, or delete any
        QuickBooks accounting records, transactions, accounts, budgets, or
        other QuickBooks data through the Staff Dashboard. Any actual
        edits to accounting data must be performed inside QuickBooks
        Online directly by an authorized bookkeeper.
      </p>

      <h2>Availability and Changes</h2>
      <p>
        Family Chapel may modify, add, remove, or discontinue features of
        the Staff Dashboard at any time. Family Chapel does not
        guarantee that the Staff Dashboard will be available at all times
        or free of errors, and may perform maintenance or updates that
        temporarily affect availability.
      </p>

      <h2>Confidential Information</h2>
      <p>
        Information within the Staff Dashboard &mdash; including staff
        information, ministry information, financial information, and
        information obtained through integrated third-party services
        &mdash; is intended for internal Family Chapel use and should be
        treated as confidential unless Family Chapel indicates otherwise.
      </p>

      <h2>Disclaimers</h2>
      <p>
        The Staff Dashboard is provided on an &ldquo;as is&rdquo; and
        &ldquo;as available&rdquo; basis for internal use. Family Chapel
        makes no warranties, express or implied, regarding the Staff
        Dashboard or the accuracy, completeness, timeliness, or
        availability of information obtained through third-party
        integrations. Reports and dashboards generated from third-party
        data are for internal informational purposes and should not be
        treated as a substitute for the authoritative records maintained
        in the underlying systems.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Family Chapel is not
        liable for indirect, incidental, special, consequential, or
        punitive damages arising out of or related to use of the Staff
        Dashboard. Nothing in these Terms limits or affects any
        obligations owed to Family Chapel personnel that cannot be
        limited or affected under applicable law.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        Family Chapel may update these Terms from time to time. The
        &ldquo;Last updated&rdquo; date at the top of this page will
        reflect the most recent revision. Continued use of the Staff
        Dashboard after an update means the updated Terms apply to that
        use.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these Terms or the Staff Dashboard should be
        directed to Family Chapel through the church&rsquo;s normal
        administrative channels.
      </p>
    </LegalPage>
  );
}
